import { defaultWidgetSet } from '../configureStore';

const processDataRequestSuccess = (state, { payload: { customizations } }) => (
    // Update the information of the requested widget with the one that comes from the server
    state.map(widgetSet => (
        (widgetSet.config.id === customizations.config.id) || !widgetSet.config.id
            ? {
                config        : { ...widgetSet.config, ...customizations.config },
                searchbar     : { ...widgetSet.searchbar, ...customizations.searchbar },
                rates         : { ...widgetSet.rates, ...customizations.rates },
                offers        : { ...widgetSet.offers, ...customizations.offer },
                hotels        : { ...widgetSet.hotels, ...customizations.hotels },
                rewardProgram : { ...widgetSet.rewardProgram, ...customizations.rewardProgram },
            }
            : widgetSet))
);

const processSetConfig = (state, action) => {
    const { payload } = action;

    // The widget set may exist or there may not be any sets loaded yet, that is the case where the id will be false
    const widgetSetExists = state.find(widgetSet => (widgetSet.config.id === action.id || !widgetSet.config.id));

    // We enable the search button if some of these properties has changed
    const updateButton = payload.widgetType === 'searchbar' && (payload.config.isConnected === false)
        ? { searchButtonEnabled: true }
        : {};

    if (widgetSetExists) {
        // Update only the corresponding widget
        return state.map((widgetSet) => {
            if (payload.widgetType !== 'config') {
                return (
                    (widgetSet.config.id === action.id || !widgetSet.config.id || !action.id) ? {
                        ...widgetSet,
                        [payload.widgetType]: {
                            ...widgetSet[payload.widgetType],
                            ...payload.config,
                            ...updateButton,
                        },
                    } : widgetSet);
            }

            return widgetSet;
        });
    }

    // Add new widget (with default model) and update the corresponding values
    return [ ...state, {
        ...defaultWidgetSet,
        [payload.widgetType]: {
            ...defaultWidgetSet[payload.widgetType],
            ...payload.config,
            ...updateButton,
        },
    } ];
};

const processSetLoadingBlocks = (state, { id, payload }) => (
    // Update only the corresponding widget
    state.map(widget => (
        (widget.config.id === id || !widget.config.id || !id) ? {
            ...widget,
            rates: {
                ...widget.rates,
                loadingBlocks: payload.loadingBlocksForRates,
            },
            offers: {
                ...widget.offers,
                loadingBlocks: payload.loadingBlocksForOffers,
            },
        } : widget))
);

const processSetNumberOfOffers = (state, { id, payload }) => (
    state.map(widget => (
        (widget.config.id === id || !widget.config.id || !id) ? {
            ...widget,
            offers: {
                ...widget.offers,
                numberOfOffers: payload.numberOfOffers,
            },
        } : widget))
);

const processSearchBar = (state, action) => {
    const isAutocompleteAction = [ 'RESET_AUTOCOMPLETE_FILTER',
        'SET_CLASSIFICATIONS' ].includes(action.type);

    const shouldEnableButton = (!isAutocompleteAction) || (action.type === 'SET_AUTOCOMPLETE_FILTER'
    && action.payload);

    const stateChanged = state.map(widget => (
        (widget.config.id === action.id) ? {
            ...widget,
            searchbar: {
                ...widget.searchbar,
                searchButtonEnabled: shouldEnableButton
                || widget.searchbar.isConnected || widget.searchbar.searchButtonEnabled,
            },
        } : widget));

    const filteredWidget = state.find(widget => (
        (widget.config.id === action.id)));

    // This is to fix: https://kognitiv.atlassian.net/browse/VPDC-26213
    if (filteredWidget?.searchbar.shouldCheckDestinationSelected) {
        if (action.payload.destinationSelected) {
            return stateChanged;
        }

        return state;
    }

    return stateChanged;
};

const processSearchResults = (state, action) => (

    // Update only the corresponding widget
    state.map(widget => (
        (widget.config.id === action.id) ? {
            ...widget,
            searchbar: {
                ...widget.searchbar,
                searchButtonEnabled: widget.searchbar.isConnected ? false : widget.searchbar.searchButtonEnabled,
            },
        } : widget))
);

const processUpdateCoupon = (state) => {
    const stateChanged = state.map(widget => (
        {
            ...widget,
            searchbar: {
                ...widget.searchbar,
                searchButtonEnabled: true,
            },
        }));

    return stateChanged;
};

const widgetPool = (state = [], action = { type: null }) => {
    switch (action.type) {
        case 'DATA_REQUEST_SUCCESS':

            return processDataRequestSuccess(state, action);

        case 'SET_CONFIG':

            return processSetConfig(state, action);

        case 'SET_LOADING_BLOCKS':

            return processSetLoadingBlocks(state, action);

        case 'CHANGE_PROMO_CODE':
        case 'CHANGE_ROOMS_QUANTITY':
        case 'CHANGE_ADULTS':
        case 'CHANGE_CHILDREN':
        case 'CHANGE_CHILDREN_AGE':
        case 'CHANGE_DATES':
        case 'SET_AUTOCOMPLETE_FILTER':
        case 'RESET_AUTOCOMPLETE_FILTER':
        case 'SET_CLASSIFICATIONS':
        case 'CHANGE_PROMO_CODE':

            return processSearchBar(state, action);

        case 'SEARCH_RESULTS':

            return processSearchResults(state, action);
        case 'UPDATE_COUPON':
            return processUpdateCoupon(state);
        case 'SET_NUMBER_OF_OFFERS':
            return processSetNumberOfOffers(state, action);
        default:
            return state;
    }
};

export default widgetPool;
